import { render, staticRenderFns } from "./ProductUpsellNew.vue?vue&type=template&id=466cfdea"
import script from "./ProductUpsellNew.vue?vue&type=script&lang=js"
export * from "./ProductUpsellNew.vue?vue&type=script&lang=js"
import style0 from "./scss/product-upsell.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('466cfdea')) {
      api.createRecord('466cfdea', component.options)
    } else {
      api.reload('466cfdea', component.options)
    }
    module.hot.accept("./ProductUpsellNew.vue?vue&type=template&id=466cfdea", function () {
      api.rerender('466cfdea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/greenmotion-shared/Components/quotes/ProductUpsellNew.vue"
export default component.exports